import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { SoftwareBitbucketPricingPage } from "../pages/software/bitbucket/pricing/software-bitbucket-pricing-page";

initRelay(
    SoftwareBitbucketPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars("bitbucket", window.location),
    RELAY_API_CONTENTFUL
);
